// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite";

import TomSelect from "tom-select";

import "trix"
import "@rails/actiontext"

// Import flatpickr for date range picker
import flatpickr from "flatpickr"

// Import Chart.js for statistics charts
import Chart from 'chart.js/auto'

// Make Chart.js globally available
window.Chart = Chart

// Make flatpickr globally available for debugging
window.flatpickr = flatpickr

document.addEventListener("turbo:load", () => {
    initFlowbite();
});
